import { Configuration } from '@h2/types';

export function createTaskTypeCreationConfiguration(): Configuration {
  return {
    id: 'task-type-creation',
    title: '작업유형 생성',
    description: '새로운 작업유형을 생성합니다',
    sections: [
      {
        id: 'basic-info',
        title: '기본 정보',
        description: '작업유형의 기본 정보를 설정합니다',
        fields: [
          {
            id: 'name',
            label: '이름',
            type: 'text',
            value: '',
            validation: {
              rules: [
                { type: 'required', message: '작업유형 이름을 입력해주세요' },
                { type: 'minLength', value: 2, message: '최소 2글자 이상 입력해주세요' }
              ]
            }
          },
          {
            id: 'description',
            label: '설명',
            type: 'textarea',
            value: '',
            validation: {
              rules: [
                { type: 'maxLength', value: 500, message: '최대 500자까지 입력 가능합니다' }
              ]
            }
          },
          {
            id: 'tags',
            label: '태그',
            type: 'simple-tags',
            value: []
          }
        ]
      },
      {
        id: 'display-info',
        title: '표시 정보',
        description: '작업자에게 보여질 정보와 시각적 요소를 설정합니다',
        fields: [
          {
            id: 'workerDisplayName',
            label: '작업자 표시 이름',
            type: 'text',
            value: '',
            validation: {
              rules: [
                { type: 'maxLength', value: 100, message: '최대 100자까지 입력 가능합니다' }
              ]
            }
          },
          {
            id: 'workerDisplayDescription',
            label: '작업자 표시 설명',
            type: 'textarea',
            value: '',
            validation: {
              rules: [
                { type: 'maxLength', value: 300, message: '최대 300자까지 입력 가능합니다' }
              ]
            }
          },
          {
            id: 'languageDependent',
            label: '다국어 작업',
            type: 'task-type-language-checkbox',
            value: false
          },
          {
            id: 'icon',
            label: '아이콘',
            type: 'task-type-icon-picker',
            value: 'Settings', // 기본 아이콘
            validation: {
              rules: []
            }
          },
          {
            id: 'color',
            label: '색상',
            type: 'task-type-color-picker',
            value: '#6B7280', // 기본 회색
            validation: {
              rules: []
            }
          }
        ]
      },
      {
        id: 'editor-options',
        title: '에디터 옵션 (CAT-Tool 옵션)',
        description: '작업 도구의 권한과 기능을 설정합니다',
        fields: [
          {
            id: 'editorOptions',
            label: '',
            type: 'task-type-editor-options',
            value: {
              source: {
                readPermission: false,
                writePermission: false,
                workTarget: false,
                downloadAsFile: false,
                updateFromFile: false,
                timecodeEdit: false
              },
              target: {
                readPermission: false,
                writePermission: false,
                workTarget: false,
                downloadAsFile: false,
                updateFromFile: false,
                timecodeEdit: false
              },
              video: {
                fullViewRequired: false,
                downloadAllowed: false
              },
              comment: {
                readPermission: false,
                writePermission: false,
                workTarget: false
              }
            }
          }
        ]
      }
    ],
    validation: {
      rules: [
        {
          type: 'custom',
          validator: (formData: any) => {
            if (!formData.name || formData.name.trim().length === 0) {
              return '작업유형 이름을 입력해주세요';
            }
            return null;
          }
        }
      ]
    }
  };
}
